module.exports = __webpack_public_path__ + "static/media/map-marker.0f0d54ae.svg";